import {
    CAlert,
    CBadge,
    CButton,
    CButtonGroup,
    CCol,
    CDropdown,
    CDropdownDivider,
    CDropdownItem,
    CDropdownMenu,
    CDropdownToggle,
    CFormInput,
    CFormLabel,
    CInputGroup,
    CModal,
    CModalBody,
    CModalHeader,
    CModalTitle,
    CRow,
    CSpinner,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow
} from "@coreui/bootstrap-react"
import {useEffect, useState} from "react";


import {toast} from "react-hot-toast";
import Communication from "../communication";
import config from "../config";
import axios from "axios";

const Holder = ({data}) => {
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [file, setFile] = useState()
    const [holders, setHolders] = useState([])
    const [msg, setMsg] = useState("برای دریافت هلدر های مشترک با توکن، لطفا روی دکمه بررسی کلیک نمایید.")

    const handelAnalysis = async () => {
        setLoading(true)
        const formData = new FormData();
        formData.append('address', data.address);
        formData.append('file', file);

        Communication.postMethod(
            config.endPoints.holder,
            formData
        ).then(data => {
            if (data['address']) {
                setHolders(groupDataByAddress(data['address']))
                if (data['address'].length <= 0) {
                    setMsg('متاسفانه توکن مورد نظر هیچ هولدر مشترکی با شما ندارد.')
                    toast.error('متاسفانه توکن مورد نظر هیچ هولدر مشترکی با شما ندارد.')
                } else {
                    toast.success('لیست هولدر های مشترک شما یافت گردید.')
                }
            } else {
                setMsg('توکن مورد نظر هیچ هلدر مشترکی با شما ندارد.')
                toast.error('توکن مورد نظر هیچ هلدر مشترکی با شما ندارد.')
            }
            setLoading(false)
        }).catch((e) => {
            console.log(e)
            toast.error('خطا در برقراری ارتباط سرور!')
            setLoading(false)
        }).finally(() => {
        })
    }

    const groupDataByAddress = (data) => {
        const groupedData = {};
        const groupedFullData = {};
        data.forEach((item) => {
            if (!groupedData[item.address]) {
                groupedData[item.address] = [];
            }
            groupedData[item.address].push(item?.file?.name);
        });

        data.forEach((item) => {
            if (!groupedFullData[item.address]) {
                groupedFullData[item.address] = [];
            }
            if (item?.name !== null) {
                groupedFullData[item.address] = item;
            }
        });

        return Object.keys(groupedData).map((address) => ({
            id: groupedFullData[address].id,
            address,
            name: groupedFullData[address].name,
            files: groupedData[address],
            balance: groupedFullData[address].balance,
            information: groupedFullData[address].information
        }));
    };


    const updateBalance = (address) => {
        setLoading(true)
        Communication.postMethod(
            config.endPoints.balance,
            {address: address}
        ).then(data => {
            setHolders(holders.map((item, idx) => {
                if (item['address'] === address) {
                    return {
                        ...item,
                        balance: data['data']['balance'],
                        token_balance: data['data']['token_balance'],
                    };
                }
                toast.success('موجود آدرس مورد نظر شما با موفقیت دریافت گردید.')
                return item;
            }))
            setLoading(false)
        }).catch(() => {
            toast.error('خطا در برقراری ارتباط سرور!')
            setLoading(false)
        }).finally(() => {
        })
    }

    return (
        <>
            <br/>
            <CModal size="xl" visible={visible} onClose={() => setVisible(false)}>
                <CModalHeader>
                    <CModalTitle>هلدر چکر</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <CRow>
                        <CTable>
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">#</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">نام</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">موجودی</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">موجودی توکن</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">فایل</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">توضیحات</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">آدرس</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">عملیات</CTableHeaderCell>
                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {holders.length > 0 ? (
                                    <>
                                        {
                                            holders.map((item) => (
                                                <CTableRow>
                                                    <CTableHeaderCell scope="row">
                                                        {item['id']}
                                                    </CTableHeaderCell>
                                                    <CTableHeaderCell>
                                                        {item['name']}
                                                    </CTableHeaderCell>

                                                    <CTableHeaderCell>
                                                        {parseFloat(item['balance']).toFixed(8)}
                                                    </CTableHeaderCell>

                                                    <CTableHeaderCell>
                                                        {item['token_balance']}
                                                    </CTableHeaderCell>
                                                    {item.files.length > 1 ? (
                                                        <CTableHeaderCell>
                                                            <CDropdown variant="btn-group">
                                                                <CDropdownToggle color="primary" variant="ghost">
                                                                    {item.files[0]} {' '}
                                                                    <CBadge
                                                                        color="danger"> {item.files.length} </CBadge>
                                                                </CDropdownToggle>
                                                                <CDropdownMenu>
                                                                    {item.files.map((item) => (
                                                                        <CDropdownItem>{item}</CDropdownItem>
                                                                    ))}
                                                                </CDropdownMenu>
                                                            </CDropdown>
                                                        </CTableHeaderCell>
                                                    ) : (
                                                        <CTableHeaderCell>
                                                            {item.files[0]} {' '}
                                                        </CTableHeaderCell>
                                                    )}
                                                    <CTableHeaderCell>
                                                        {item['information']}
                                                    </CTableHeaderCell>

                                                    <CTableHeaderCell>
                                                        <a href={"https://etherscan.io/address/" + item['address']}
                                                           target='_blank'>
                                                            {item?.address?.slice(-6)}
                                                        </a>
                                                    </CTableHeaderCell>
                                                    <CTableHeaderCell>
                                                        <CButton color="primary" size="sm" className="position-relative"
                                                                 onClick={() => updateBalance(item['address'])}
                                                                 disabled={loading}>
                                                            {loading ? (
                                                                <>درحال بررسی موجودی ... </>
                                                            ) : (
                                                                <>بررسی موجودی</>
                                                            )}
                                                        </CButton>
                                                    </CTableHeaderCell>
                                                </CTableRow>
                                            ))
                                        }
                                    </>
                                ) : (
                                    <CTableRow>
                                        <CTableHeaderCell scope="row">
                                            <CAlert color="warning">
                                                {msg}
                                            </CAlert>
                                        </CTableHeaderCell>
                                    </CTableRow>
                                )}
                            </CTableBody>
                        </CTable>

                        <CCol xs="auto">
                            <CInputGroup className="mb-3">
                                <CFormInput
                                    type="file" id="inputGroupFile03" aria-describedby="inputGroupFileAddon03"
                                    aria-label="آپلود"
                                    onChange={(e) => (setFile(e.target.files[0]))}
                                />
                            </CInputGroup>
                            <CButton type="submit" className="mb-3" onClick={() => (handelAnalysis())}
                                     disabled={loading}>
                                {loading ? (
                                    <>درحال بررسی هولدر ها ... </>
                                ) : (
                                    <>بررسی هلدر های مشترک</>
                                )}
                            </CButton>
                        </CCol>
                    </CRow>
                </CModalBody>
            </CModal>
            <CButton color="warning" className="position-relative" onClick={() => setVisible(!visible)}>
                هلدر چکر
            </CButton>
        </>


    )
}

export default Holder;